import CampaignOutlined from '@mui/icons-material/CampaignOutlined';
import InfoOutlined from '@mui/icons-material/InfoOutlined';

import GXIcon from '@/assets/icons/GXIcon';
import NewPriceIcon from '@/assets/icons/NewPrice';

import type { FeedInfo } from '../types';

export const FeedIcon = ({ Type }: Pick<FeedInfo['symbol'], 'Type'>) => {
  switch (Type.replaceAll(/\s/g, '')) {
    case 'NewPrice':
      return <NewPriceIcon />;
    case 'Alert':
      return <InfoOutlined />;
    case 'System':
      return <CampaignOutlined />;
    default:
      return <GXIcon />;
  }
};
